<template>
  <div class="checkpoint-block">
    <div class="checkpoint-block__result">
      <input-item
        v-model="model.result"
        :name="resultName"
        :rules="rules.result"
        placeholder="Сформулируйте результат"
      >
        <template #suffix>
          <icon-delete 
            v-if="1 < countCheckpoints"
            @click="() => $emit('remove', index)"
          />
        </template>
      </input-item>
    </div>

    <check-point-date-layout>
      <template #date>
        <date-picker-item
          v-model="model.date"  
          :disabled="model.noMatter"
          :name="dateName"
          placeholder="Дата выполнения"
          :rules="rules.date"
        >
          <template #suffixIcon></template>
        </date-picker-item>
      </template>
      <template #no-matter>
        <checkbox-item
          v-model="model.noMatter"
          :name="noMatterName"
          :rules="rules.noMatter"
          @change="() => $emit('change-no-matter', model.noMatter, index)"
        >
          Неважно
        </checkbox-item>
      </template>
    </check-point-date-layout>
  </div>
</template>

<script setup>
  import { computed, defineModel } from 'vue';
  import CheckboxItem from '@/components/form/components/CheckboxItem.vue';
  import DatePickerItem from '@/components/form/components/DatePickerItem.vue';
  import IconDelete from '@/components/form/components/IconDelete.vue';
  import InputItem from '@/components/form/components/InputItem.vue';
  import CheckPointDateLayout from './CheckPointDateLayout.vue';

  const model = defineModel();

  const props = defineProps({
    rules: {
      type: Object,
      required: true,
    },
    countCheckpoints: {
      type: Number,
      default: 1,
    },
    index: Number,
    name: String,
  });

  defineEmits(['remove', 'change-no-matter']);

  const computeName = (name) => {
    if (undefined === props.name || undefined === props.index) {
      return name;
    }

    return [props.name, props.index, name];
  }

  const resultName = computed(() => computeName('result'));
  const dateName = computed(() => computeName('date'));
  const noMatterName = computed(() => computeName('noMatter'));
</script>

<style lang="scss" scoped>
  .checkpoint-block {
    display: flex;
    flex-direction: column;
    gap: 10px;

    .form-item {
      margin: 0;
    }
  }
</style>